import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MasterSettingsService {
  constructor( private readonly http  : HttpClient) {}

  baseURL = environment.baseAPIURL;

  loadFilterValues() {
    return this.http
      .get(`${this.baseURL}/aetDashBoard/filter/onLoad`, {
        responseType: 'json',
      })
      .pipe(catchError(this.handleError));
  }

  loadMasterConfig() {
    return this.http
      .get(`${this.baseURL}/aetDashBoard/masterConfig`, {
        responseType: 'json',
      })
      .pipe(catchError(this.handleError));
  }

  loadMasterSettingsOfDomicile() {
    return this.http
      .get(`${this.baseURL}/aetDashBoard/masterConfig/config`, {
        responseType: 'json',
      })
      .pipe(catchError(this.handleError));
  }

  updateMasterSettings(params: {
    domicile: string;
    updateTrigger: number;
    redTrigger: number;
    yellowTrigger: number;
    snoozeDelay: number;
  }) {
    return this.http
      .put(
        `${this.baseURL}/aetDashBoard/masterConfig/update`,
        {},
        {
          params: params,
          responseType: 'json',
        }
      )
      .pipe(catchError(this.handleError));
  }

  resetMasterSettings(params: {
    domicile: string;
  }) {
    return this.http
      .put(
        `${this.baseURL}/aetDashBoard/masterConfig/reset`,
        {},
        {
          params: params,
          responseType: 'json',
        }
      )
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    return throwError(error.message || 'Server Error');
  }
}
